<template>
  <LineChart
    :request-status="requestStatus"
    :series="series"
    :title="title"
    :item-id="itemId"
    class="make-a-copy"
    :card-options="cardOptions"
    :show-granularity="false"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import LineChart from '@/components/cards/models/LineChart';
import blipModel from '@/mixins/blip-model';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import { setDateToUTC } from '@/utils/date';
import cardsModel from '@/mixins/cards-model';

export default {
  name: 'BaseBlipLineChart',
  components: {
    LineChart,
  },
  mixins: [
    cardsModel,
    blipModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    servicePath: {
      type: String,
      required: true,
    },
    interval: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      undefinedLabeL: this.$t('DataManagement.undefined'),
      rawSeries: [],
      filteredValues: [],
      categories: [],
      cardFilters: {},
      cardOptions: {
        chart: {
          type: 'spline',
        },
        xAxis: {},
        yAxis: {
          min: null,
          plotLines: [{
            color: '#515156',
            width: 1,
            value: 0,
          }],
          labels: {
            enabled: true,
          },
        },
        legend: {
          enabled: true,
        },
        plotOptions: {
          series: {
            marker: {
              enabled: false,
              symbol: 'circle',
            },
          },
        },
      },
    };
  },
  computed: {
    series() {
      if (Boolean(this.rawSeries?.length)) {
        const seriesObject = this.rawSeries.reduce((newSeriesObject, { to, resource }) => {
          const botName = this.getBotName(to, this.cardFilters);

          if (!Boolean(newSeriesObject[botName])) {
            newSeriesObject[botName] = [];
          }

          newSeriesObject[botName] = { data: [...resource.items] };

          return newSeriesObject;
        }, {});

        const processSeriesObject = Object.keys(seriesObject)
          .map(name => ({
            name,
            data: seriesObject[name].data.map(data => ({
              x: setDateToUTC(data.intervalStart).getTime(),
              y: data.count,
            })),
          }));

        return processSeriesObject;
      }

      return [];
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getBlipService',
      'hasNoBlipBotAndContractFiltered',
      'getAppliedCardFilter',
    ]),
    async getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      if (await this.hasNoBlipBotAndContractFiltered(this.itemId)) {
        this.requestStatus = 'emptyBot';
        return;
      }

      this.cardFilters = await this.getAppliedCardFilter(this.itemId);

      this.getBlipService({
        servicePath: this.servicePath,
        interval: this.interval,
        itemId: this.itemId,
      })
        .then((responses) => {
          if (!responses) {
            this.requestStatus = 'error';
            return;
          }

          this.rawSeries = responses;
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch((error) => {
          console.error(error);
          this.requestStatus = error.message;
        });
    },
  },
};
</script>
